import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Determine initial language from URL or localStorage
    const location = useLocation();
    const navigate = useNavigate();
    
    const getInitialLang = () => {
        const path = window.location.pathname;
        if (path.startsWith('/tr')) return 'tr';
        
        const savedLang = localStorage.getItem('gnm_lang');
        return savedLang || 'en';
    };

    const [lang, setLang] = useState(getInitialLang());

    // Sync state with URL and localStorage
    useEffect(() => {
        const path = location.pathname;
        if (path.startsWith('/tr') && lang !== 'tr') {
            setLang('tr');
        } else if (!path.startsWith('/tr') && lang === 'tr') {
            // If they are on root but lang is TR, we let them stay (maybe switched manually)
            // But usually we want URL consistency for SEO
        }
    }, [location.pathname]);

    const changeLanguage = (newLang) => {
        setLang(newLang);
        localStorage.setItem('gnm_lang', newLang);
        
        const currentPath = location.pathname;
        if (newLang === 'tr') {
            if (!currentPath.startsWith('/tr')) {
                // Avoid double slash: /tr + / = /tr/ (wrong). Should be /tr
                const cleanPath = currentPath === '/' ? '' : currentPath;
                navigate('/tr' + cleanPath, { replace: true });
            }
        } else {
            if (currentPath.startsWith('/tr')) {
                const stripped = currentPath.replace('/tr', '');
                navigate(stripped || '/', { replace: true });
            }
        }
    };

    return (
        <LanguageContext.Provider value={{ lang, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
